"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DocumentDollar16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 0H1V15H7V13H3V2H13V6.5H15V0ZM11 4H5V6H11V4ZM11.5 7C11.2239 7 11 7.22386 11 7.5V8.27483C9.83135 8.46836 9.19953 9.31291 9.19953 10.26C9.19953 11.8002 10.4403 12.0836 11.4131 12.3059C12.0404 12.4492 12.5563 12.5671 12.5563 12.98C12.5563 13.38 12.2512 13.66 11.6056 13.66C10.9014 13.66 10.0681 13.22 9.64554 12.7667L9 13.9933C9.48917 14.5054 10.2135 14.8484 11 14.9566V15.5C11 15.7761 11.2239 16 11.5 16C11.7761 16 12 15.7761 12 15.5V14.9663C13.2825 14.8111 14 14.0042 14 12.94C14 11.3185 12.6898 11.0194 11.7036 10.7943C11.1085 10.6585 10.6315 10.5496 10.6315 10.1933C10.6315 9.83333 10.9836 9.56667 11.5235 9.56667C12.216 9.56667 12.8615 9.91333 13.2019 10.3133L13.8005 9.11333C13.3346 8.69433 12.7322 8.36651 12 8.26562V7.5C12 7.22386 11.7761 7 11.5 7ZM5 7H8V9H5V7Z", fill: "#131416" }));
}
function DocumentDollar16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DocumentDollar16Svg, Object.assign({}, svgProps)));
}
exports.default = DocumentDollar16;
//# sourceMappingURL=DocumentDollar16.js.map